export default __webpack_public_path__ + "8495c40ac2f0333500bab464211a1ff5.png";